module.exports = __webpack_public_path__ + "img/arrow-right.5a773e4e.svg";